var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"http://przemeknowak.com"}},[_vm._v("See more")])])
}]

export { render, staticRenderFns }